<!-- Copyright (c) 2023 Cigent Technology Inc. All Rights Reserved. -->
<app-cigent-header
  smallTitle=""
  largeTitle="{{'DIV_ACC_ACTIVATE' | translate}}"
  description="{{'INV_DESCRIPTION' | translate}}"
  descriptionMarginRight="215px">
</app-cigent-header>
<div class="welcome">
    <div *ngIf="showLogin">
        <app-login-ms
            [showMsLogin]="false"
            [loginImmediately]="true"
            [authenticateCigentUser]="false"
            (handleLogin)="activateWhenLoggedIn($event)"></app-login-ms>
    </div>
    <div><h2>{{ 'W_HEADER' | translate }}</h2></div>
    <div class="message"> <span> {{message | translate }}</span></div>
    <div class="mat-error"> <span>{{error | translate }}</span></div>
    <br>
    <br>
    <div class="mat-error" *ngIf="error.length > 0">{{'azure.activate.try-again' | translate}}
        <a href="https://support.cigent.com/support/home" target="_blank" rel="noopener noreferrer">{{ 'APP_CONTACT' | translate}}</a>
    </div>

    <div class="dologin" *ngIf="activated"><a href="{{loginUrl}}">{{'azure.activate.sign-in' | translate}}</a></div>

</div>
<app-cigent-capabilities></app-cigent-capabilities>
